import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { EfficiencyMiniBar } from '../../components/custodian/EfficiencyMiniBar';

const RECEIPTS = [
  {
    id: 'CR-33-2194',
    issued: 'Mar 21, 2025 · 09:12',
    asset: 'A-93284 / Loan-L-92189',
    facility: 'PNC-SPV-92314',
    eff: 94,
    effVariant: 'good',
    assetType: 'Multi-phone admission',
    originator: 'Originator',
    issuedBy: 'Custodian operator',
    bundle: 'EB-92384',
    delivery: 'Delivered',
  },
  {
    id: 'CR-33-2193',
    issued: 'Mar 21, 2025 · 08:40',
    asset: 'A-18802 / Loan-L-18802',
    facility: 'UMB Line A',
    eff: 88,
    effVariant: 'good',
    assetType: 'Whole loan',
    originator: 'UMB Originator',
    issuedBy: 'Custodian operator',
    bundle: 'EB-18802-01',
    delivery: 'Delivered',
  },
  {
    id: 'CR-33-2192',
    issued: 'Mar 20, 2025 · 16:02',
    asset: 'A-18801 / Loan-L-18801',
    facility: 'UMB Line A',
    eff: 62,
    effVariant: 'warn',
    assetType: 'Participation',
    originator: 'UMB Originator',
    issuedBy: 'Custodian operator',
    bundle: 'EB-18801-02',
    delivery: 'Pending signature',
  },
];

export function CustodianReceiptsPage() {
  const [selectedId, setSelectedId] = useState(RECEIPTS[0].id);
  const selected = useMemo(
    () => RECEIPTS.find((r) => r.id === selectedId) ?? RECEIPTS[0],
    [selectedId],
  );
  const assetSlug = selected.asset.split('/')[0].trim();

  return (
    <div className="page-stack">
      <header className="flex flex-col gap-3 border-b border-evault-border pb-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-xl font-semibold text-evault-navy">
            Admit custody receipts
          </h1>
          <p className="mt-1 max-w-2xl text-xs text-evault-muted">
            Custody receipt register — issued receipts, delivery state, and
            evidence bundle linkage.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="rounded-full border border-evault-border bg-white px-3 py-1 text-[11px] font-semibold text-evault-navy shadow-sm"
          >
            Generate
          </button>
          <button
            type="button"
            className="rounded-full bg-evault-navy px-3 py-1 text-[11px] font-semibold text-white shadow-sm"
          >
            Export
          </button>
        </div>
      </header>

      <section className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <div className="card-shell p-3">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
            Admit receipts
          </p>
          <p className="mt-1 text-2xl font-semibold text-evault-navy">16</p>
          <p className="mt-1 text-[10px] text-evault-muted">+3 today</p>
        </div>
        <div className="card-shell p-3">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
            Issued today
          </p>
          <p className="mt-1 text-2xl font-semibold text-evault-navy">34</p>
          <p className="mt-1 text-[10px] text-evault-muted">+8 vs avg</p>
        </div>
        <div className="card-shell p-3">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
            Delivery failures
          </p>
          <p className="mt-1 text-2xl font-semibold text-evault-navy">1</p>
          <p className="mt-1 text-[10px] text-evault-gold">needs repair</p>
        </div>
        <div className="card-shell p-3">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
            Pending signatures
          </p>
          <p className="mt-1 text-2xl font-semibold text-evault-navy">7</p>
          <p className="mt-1 text-[10px] text-evault-gold">requires attention</p>
        </div>
      </section>

      <section className="grid gap-4 lg:grid-cols-[minmax(0,2fr)_minmax(260px,1fr)]">
        <div className="table-shell overflow-x-auto">
          <table className="min-w-full border-collapse text-left text-[11px]">
            <thead className="bg-evault-surface text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
              <tr>
                <th className="px-3 py-2">Receipt ID</th>
                <th className="px-3 py-2">Issued</th>
                <th className="px-3 py-2">Asset</th>
                <th className="px-3 py-2">Facility</th>
                <th className="px-3 py-2">Efficiency</th>
              </tr>
            </thead>
            <tbody>
              {RECEIPTS.map((r) => {
                const active = r.id === selected.id;
                return (
                  <tr
                    key={r.id}
                    className={`cursor-pointer border-t border-evault-border ${
                      active ? 'bg-evault-surface' : 'hover:bg-evault-surface/60'
                    }`}
                    onClick={() => setSelectedId(r.id)}
                  >
                    <td className="px-3 py-2 font-semibold text-evault-navy">
                      {r.id}
                    </td>
                    <td className="px-3 py-2 text-evault-muted">{r.issued}</td>
                    <td className="px-3 py-2 text-evault-navy">{r.asset}</td>
                    <td className="px-3 py-2 text-evault-muted">{r.facility}</td>
                    <td className="px-3 py-2">
                      <EfficiencyMiniBar pct={r.eff} variant={r.effVariant} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <aside className="card-shell flex flex-col gap-3 p-4">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
              Selected receipt
            </p>
            <p className="mt-1 text-sm font-semibold text-evault-navy">
              Receipt ID: {selected.id}
            </p>
          </div>
          <dl className="space-y-2 text-[11px]">
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Asset
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.asset}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Asset type
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.assetType}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Originator
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.originator}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Facility
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.facility}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Issued by
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.issuedBy}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Initial evidence bundle
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.bundle}</dd>
            </div>
            <div>
              <dt className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
                Current delivery state
              </dt>
              <dd className="mt-0.5 text-evault-navy">{selected.delivery}</dd>
            </div>
          </dl>
          <div className="flex flex-wrap gap-2 border-t border-evault-border pt-3">
            <button
              type="button"
              className="rounded-full bg-evault-teal-deep px-3 py-1 text-[11px] font-semibold text-white"
            >
              View PDF
            </button>
            <button
              type="button"
              className="rounded-full border border-evault-border bg-white px-3 py-1 text-[11px] font-semibold text-evault-navy"
            >
              Refresh
            </button>
            <button
              type="button"
              className="rounded-full border border-evault-border bg-white px-3 py-1 text-[11px] font-semibold text-evault-navy"
            >
              Resend
            </button>
          </div>
          <div className="border-t border-evault-border pt-3 text-[11px]">
            <p className="text-[10px] font-semibold uppercase tracking-wide text-evault-muted">
              Related
            </p>
            <ul className="mt-2 space-y-1.5 text-evault-teal-deep">
              <li>
                <Link to="/custodian/explorer" className="hover:underline">
                  View facility/trust
                </Link>
              </li>
              <li>
                <Link
                  to={`/custodian/assets/${assetSlug}`}
                  className="hover:underline"
                >
                  View asset
                </Link>
              </li>
              <li>
                <Link
                  to="/custodian/evidence/bundles"
                  className="hover:underline"
                >
                  View evidence bundle
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      </section>
    </div>
  );
}
